export default "__VITE_ASSET__vhkQ9cwV__"